export default __webpack_public_path__ + "static/media/bootcamper.d5a1c82c.png";